import * as M from 'shared/types/models';

export function getRangeByID(id: string, columns: M.Column[], idType: 'markupID' | 'categoryID' = 'markupID'): M.Range {
  const indexes = columns.reduce<number[]>((acc, column, index) =>
    column[idType] === id ? [...acc, index] : acc,
    [],
  );
  return { start: indexes[0], end: indexes[indexes.length - 1] };
}
